var _excluded = ["details", "initialListings"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import MobileFooterCTA from '@domain-group/fe-co-allhomes-agent-mobile-cta';
import { AgentRecommendationsGraphQL } from '@domain-group/fe-co-allhomes-agent-recommendations';
import { usePageViewEvent, EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Separator } from '@domain-group/fe-co-allhomes-design-system';
import { AgentEnquiryForm } from '@domain-group/fe-co-allhomes-enquiry-form';
import AllhomesListingCard, { AllhomesListingCardsTabs } from '@domain-group/fe-co-allhomes-listing-card';
import StickyFooter from '@domain-group/fe-co-allhomes-sticky-footer';
import AgencyMemberships from './components/agency-memberships';
import AllhomesAgencyModel from './components/agency-model';
import AllhomesAgencyHeader from './components/agency-header';
import AllhomesAgencyBody from './components/agency-body';
import AllhomesAgencyFooter from './components/agency-footer';
import AgencyArticles from './components/agency-articles';
import { articleProps } from './common-props';
import AllhomesAgentCardList from './components/agent-card/allhomes-agent-card-list';
import * as styles from './allhomes-agency-profile-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgencyProfilePage = _ref => {
  var details = _ref.details,
    initialListings = _ref.initialListings,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    emailEnquiryModalOpen = _useState2[0],
    setEmailEnquiryModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showAllAgents = _useState4[0],
    setShowAllAgents = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    enquiryProps = _useState6[0],
    setEnquiryProps = _useState6[1];
  usePageViewEvent();
  var _props$media = props.media,
    smallTablet = _props$media.smallTablet,
    mobile = _props$media.mobile;
  var agents = showAllAgents || mobile ? props.agents : props.agents.slice(0, props.agentsPerPage);
  var launchEmailEnquiryModal = params => {
    setEnquiryProps({
      logoUrl: params.logo,
      formTitle: params.title,
      clientId: params.id,
      clientType: params.type
    });
    setEmailEnquiryModalOpen(true);
  };
  var onClickEmailAgent = (agentId, agentName, sourceText) => {
    launchEmailEnquiryModal({
      logo: details.images.profilePhoto,
      id: agentId,
      title: "Contact ".concat(agentName),
      type: 'AGENT',
      source: sourceText
    });
  };
  var closeEmailEnquiryModal = () => {
    setEmailEnquiryModalOpen(false);
  };
  var showMoreAgents = () => {
    setShowAllAgents(true);
  };
  var articlesLayout = () => {
    if (mobile) {
      return 'column';
    }
    if (smallTablet) {
      return 'two-row';
    }
    return 'row';
  };
  return ___EmotionJSX("div", {
    css: styles.agencyProfile
  }, ___EmotionJSX("div", {
    css: styles.bodySection
  }, ___EmotionJSX(EventBoundary, {
    name: "agency"
  }, ___EmotionJSX(AllhomesAgencyHeader, _extends({}, details, {
    enquiryFormCallback: launchEmailEnquiryModal
  })), ___EmotionJSX(AgencyMemberships, {
    memberships: details.memberships,
    agencyName: details.name
  }), ___EmotionJSX("div", {
    css: styles.insetBody
  }, ___EmotionJSX(AllhomesAgencyBody, {
    description: details.description,
    maxPreviewHeight: props.maxPreviewHeight,
    stats: props.stats
  })), props.articles.length > 0 && ___EmotionJSX(Fragment, null, ___EmotionJSX(Separator, {
    css: styles.separator
  }), ___EmotionJSX(AgencyArticles, {
    layout: articlesLayout(),
    articles: props.articles
  }), ___EmotionJSX(Separator, {
    css: styles.separator
  }))), ___EmotionJSX("div", {
    css: styles.insetBody
  }, ___EmotionJSX(EventBoundary, {
    name: "agents"
  }, ___EmotionJSX(AllhomesAgentCardList, {
    agencyId: details.id,
    agents: agents,
    hasMore: agents.length < props.agents.length,
    onFetchMore: showMoreAgents,
    onClickEmail: onClickEmailAgent,
    title: "Agents from ".concat(details.name),
    titleTagType: "h2"
  })), ___EmotionJSX(AllhomesListingCardsTabs, {
    titleTagType: "h2",
    css: styles.listings,
    title: "Listings by ".concat(details.name),
    sourceId: details.id,
    sourceType: "agency",
    tabs: [{
      id: 'sales',
      label: 'For Sale',
      labelMobile: 'Sale',
      totalCount: initialListings.sales.total,
      initialSearchResult: initialListings.sales.listings,
      subTitle: "".concat(initialListings.sales.total, " ").concat(initialListings.sales.total > 1 ? 'properties' : 'property', " for sale"),
      duration: ''
    }, {
      id: 'rentals',
      label: 'For Rent',
      labelMobile: 'Rent',
      totalCount: initialListings.rentals.total,
      initialSearchResult: initialListings.rentals.listings,
      subTitle: "".concat(initialListings.rentals.total, " ").concat(initialListings.rentals.total > 1 ? 'properties' : 'property', " for rent"),
      duration: ''
    }, {
      id: 'sold',
      label: 'Sold',
      labelMobile: 'Sold',
      totalCount: initialListings.recentlySold.total,
      initialSearchResult: initialListings.recentlySold.listings,
      subTitle: "".concat(initialListings.recentlySold.total, " ").concat(initialListings.recentlySold.total > 1 ? 'properties' : 'property', " sold"),
      duration: "Last ".concat(props.listingVisibility.sale.duration, " ").concat(props.listingVisibility.sale.unit, "s")
    }, {
      id: 'rented',
      label: 'Rented',
      labelMobile: 'Rented',
      totalCount: initialListings.recentlyRented.total,
      initialSearchResult: initialListings.recentlyRented.listings,
      subTitle: "".concat(initialListings.recentlyRented.total, " ").concat(initialListings.recentlyRented.total > 1 ? 'properties' : 'property', " rented"),
      duration: "Last ".concat(props.listingVisibility.rent.duration, " ").concat(props.listingVisibility.rent.unit, "s")
    }]
  }), props.reviewProfile && ___EmotionJSX("div", {
    css: styles.recommendations
  }, ___EmotionJSX(AgentRecommendationsGraphQL, {
    reviewProfile: props.reviewProfile
  })))), ___EmotionJSX(EventBoundary, {
    name: "footer"
  }, ___EmotionJSX(AllhomesAgencyFooter, {
    profile: details,
    enquiryFormCallback: launchEmailEnquiryModal,
    googleMapsParams: props.googleMapsParams,
    geocoderEndpoint: props.geocoderEndpoint
  })), emailEnquiryModalOpen && ___EmotionJSX(AgentEnquiryForm, _extends({
    endpointUrl: props.enquiryEndpoint,
    closeCallback: closeEmailEnquiryModal
  }, enquiryProps)), mobile && (details.emailContactable || details.phone) && ___EmotionJSX(StickyFooter, null, ___EmotionJSX(MobileFooterCTA, {
    phone: details.phone,
    onEmailClick: details.emailContactable ? () => launchEmailEnquiryModal({
      id: details.id,
      title: "Contact ".concat(details.name),
      logo: details.images.profilePhoto,
      type: 'AGENCY',
      source: 'FooterCTA'
    }) : undefined
  })));
};
AllhomesAgencyProfilePage.propTypes = {
  details: PropTypes.shape(AllhomesAgencyModel),
  agentsPerPage: PropTypes.number,
  maxPreviewHeight: PropTypes.number,
  agents: AllhomesAgentCardList.propTypes.agents,
  initialListings: PropTypes.shape({
    sales: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    rentals: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    recentlySold: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    recentlyRented: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    })
  }),
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    smallTablet: PropTypes.bool
  }),
  googleMapsParams: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired,
  reviewProfile: PropTypes.shape({}),
  enquiryEndpoint: PropTypes.string,
  geocoderEndpoint: PropTypes.string,
  sendEvent: PropTypes.func,
  stats: PropTypes.shape({
    sold: PropTypes.string,
    forSale: PropTypes.string,
    averageDays: PropTypes.string,
    forRent: PropTypes.string,
    rented: PropTypes.string
  }).isRequired,
  listingVisibility: PropTypes.shape({
    sale: PropTypes.shape({
      duration: PropTypes.string,
      unit: PropTypes.string
    }),
    rent: PropTypes.shape({
      duration: PropTypes.string,
      unit: PropTypes.string
    })
  }),
  articles: PropTypes.arrayOf(articleProps)
};
AllhomesAgencyProfilePage.defaultProps = {
  agentsPerPage: 6,
  details: {},
  agents: [],
  initialListings: [],
  maxPreviewHeight: 220,
  media: {},
  reviewProfile: {},
  enquiryEndpoint: '/wsvc/enquiry/contact',
  geocoderEndpoint: '/wsvc/agency/address/geocode',
  sendEvent: () => {},
  listingVisibility: {
    sale: {
      duration: '',
      unit: ''
    },
    rent: {
      duration: '',
      unit: ''
    }
  },
  articles: []
};
export default AllhomesAgencyProfilePage;